import Async from "components/DesignSystem/AsyncComponents/Async";
import { ACCOUNT_CONNECTION_TYPE } from "constants/dataSource";
import { useCurrentEntityId } from "hooks/useCurrentEntityId";
import { useDataSourceSegregate } from "hooks/useDataSourceSegregate";
import { useGetAllConnections } from "hooks/useGetAllConnections";
import { useGetEntityBanksQuery } from "store/apis/bankConnections";
import {
  AccountBanner,
  AccountCardsSection,
  RevenueCard,
  TabEmptyState,
} from "../DataSourcesList";

export const Revenue = ({
  groupId,
  onOpenConnectionModal,
  onOpenSubscriptionModal,
}: {
  groupId: string;
  onOpenConnectionModal: () => void;
  onOpenSubscriptionModal: () => void;
}) => {
  const entityId = useCurrentEntityId();
  const {
    data: plaidConnections,
    isLoading: bankAccountsLoading,
    isSuccess: banksAccountsLoaded,
  } = useGetEntityBanksQuery(
    {
      groupId: groupId!,
      entityId: entityId!,
      type: ACCOUNT_CONNECTION_TYPE.REVENUE,
    },
    { skip: !groupId || !entityId }
  );

  const { stripeConnection } = useGetAllConnections({
    groupId: groupId!,
    entityId: entityId!,
  });

  const { totalAccounts, totalBalance, stripeConnectedBank } =
    useDataSourceSegregate(plaidConnections!);

  return (
    <Async.Root
      isSuccess={banksAccountsLoaded}
      isLoading={bankAccountsLoading}
      isEmpty={false}
    >
      <Async.Empty>
        <></>
      </Async.Empty>
      <Async.Success>
        <div className="t-overflow-y-auto t-py-3 t-px-2.5">
          {stripeConnectedBank && stripeConnection ? (
            <>
              <AccountBanner
                totalBalance={totalBalance}
                totalAccounts={totalAccounts}
              />
              <AccountCardsSection>
                <RevenueCard
                  stripeConnection={stripeConnection}
                  stripeConnectedBank={stripeConnectedBank}
                />
              </AccountCardsSection>
            </>
          ) : (
            <TabEmptyState
              title="No revenue sources connected"
              description="Connect your Stripe account to start syncing your sales & revenue automatically"
              onOpenConnectionModal={onOpenConnectionModal}
              onOpenSubscriptionModal={onOpenSubscriptionModal}
            />
          )}
        </div>
      </Async.Success>
    </Async.Root>
  );
};
